import { render, staticRenderFns } from "./rewardCoinBlastEdit.vue?vue&type=template&id=0cb2450c&scoped=true&"
import script from "./rewardCoinBlastEdit.vue?vue&type=script&lang=js&"
export * from "./rewardCoinBlastEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2450c",
  null
  
)

export default component.exports